// extracted by mini-css-extract-plugin
export default {"titleTable":"riskScaleAndInterpretation_titleTable__wlhfM","table":"riskScaleAndInterpretation_table__BFc8v","descriptionTable":"riskScaleAndInterpretation_descriptionTable__3bWLD"};